import { Copy, Eye, Pencil, Plus, Podcast, Share, Trash } from 'lucide-react'

export const ORDER_FAB = [
  {
    id: '1',
    icon: Share,
    type: 'sharePdf',
    excludeStatus: ['23'],
    label: 'Compartilhar PDF',
  },
  {
    id: '2',
    icon: Podcast,
    type: 'transmit',
    excludeStatus: ['9', '23', '4', '8', '1'],
    label: 'Transmitir pedido',
  },
  {
    id: '3',
    icon: Eye,
    type: 'viewOrder',
    excludeStatus: ['23'],
    label: 'Visualizar pedido',
  },
  {
    id: '4',
    icon: Copy,
    type: 'replicate',
    excludeStatus: ['23'],
    label: 'Replicar pedido',
  },
  {
    id: '5',
    icon: Trash,
    type: 'delete',
    excludeStatus: ['9', '8', '4', '1'],
    label: 'Deletar pedido',
  },
  {
    id: '6',
    icon: Pencil,
    type: 'edit',
    excludeStatus: ['9', '4', '8', '1'],
    label: 'Editar pedido',
  },
  {
    id: '7',
    icon: Plus,
    type: 'add',
    excludeStatus: [],
    label: 'Adicionar',
  },
]
